import { displayToast } from '../../../../helpers/notification';
import { AdminSettingTypes as Type } from '../../../types/adminsetting';

export function changeAdminPasswordRequest(body: any) {
  return {
    type: Type.CHANGE_ADMIN_PASSWORD_REQUEST,
    body: body,
  };
}

export function changeAdminPasswordSuccess(data: any) {
  localStorage.setItem('updatedName', data.firstName);
  return {
    type: Type.CHANGE_ADMIN_PASSWORD_REQUEST_SUCCESS,
    payload: data,
  };
}

export function changeAdminPasswordFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.CHANGE_ADMIN_PASSWORD_REQUEST_FAILURE,
    error: error,
  };
}

export function resetAdminPasswordState() {
  return {
    type: Type.RESET_ADMIN_CHANGE_PASSWORD_STATE,
  };
}
